module.exports = __webpack_public_path__ + "img/icon-storage-add.33af0d75.svg";